<div class="footer">
    &copy; Retirolêz
</div>